export default __webpack_public_path__ + "static/media/home-cafe-bg-img-01.5987d71e.jpg";